import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { useAppDispatch } from './redux';
import { addAccountInfo } from '../../application/store/commonReducer';
import useraction from '../containers/app/userUseCase';
/**
 * Hook for authenticating user
 *
 * @hook
 */
function useAuthCheck() {
  const dispatch = useAppDispatch();
  const { accounts } = useMsal();

  /**
   * authentication state changes are captured and aquire token
   *
   */

  useEffect(() => {
    if (Array.isArray(accounts) && accounts.length > 0) {
      dispatch(addAccountInfo(accounts[0]));
      dispatch(useraction.getUserInfo());
      useraction.loginAccessToken(accounts);
    }
  }, [accounts]);
}
export { useAuthCheck };
